import { InputLabel } from '@mui/material';

const labelSx = {
  fontSize: '0.875rem',
  lineHeight: '1.5rem',
  marginBottom: 0,
  justifyContent: 'left',
  textAlign: 'left',
};

interface IODLabel {
  lbl: string;
}

export function ODLabel({ lbl }: IODLabel) {
  const htmlFor = `od-${lbl.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <InputLabel htmlFor={htmlFor} sx={labelSx}>
      {lbl}
    </InputLabel>
  );
}
